import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentText20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDocumentText20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 17.5h9a1 1 0 0 0 1-1V8.493h-5.493V2.5H5.5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1m6.007-14.285 3.82 3.778h-3.82zM14.5 19h-9A2.5 2.5 0 0 1 3 16.5v-13A2.5 2.5 0 0 1 5.5 1h5.078a2 2 0 0 1 1.406.578l4.422 4.373A2 2 0 0 1 17 7.373V16.5a2.5 2.5 0 0 1-2.5 2.5M7 14a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zm-.75-2.75A.75.75 0 0 1 7 10.5h6a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M7 7a.75.75 0 0 0 0 1.5h1A.75.75 0 0 0 8 7z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentText20);
